<div *ngIf="submitted && password.length === 0" class="ds-input-error">
  <div>{{ 'user.error.need_pass' | translate }}</div>
</div>
<div class="ds-input-error" *ngIf="validatePasswordLength(password) && hasError && !passDontHaveIdenticalChars && submitted">
  {{ 'personal.newPassword.hints.noIdentical' | translate }}
</div>
@if (dirty) {
  <div class="tips">
    <div>
      <p class="ds-heading-3 title">{{ 'personal.newPassword.tips.title' | translate }}</p>
      <ul class="ds-list">
        <li class="ds-ui-3" [ngClass]="{ check: password.length >= minLength, error: submitted && hasError && !validatePasswordLength(password) }">
          <app-ds-icon
            size="icon-size-0"
            [color]="password.length >= minLength ? 'var(--color-core-neutral-10)' : 'var(--color-core-neutral-6)'"
            [name]="password.length >= minLength ? 'check' : 'minus'"
            *ngIf="!submitted"
          ></app-ds-icon>
          <app-ds-icon
            size="icon-size-0"
            [color]="validatePasswordLength(password) ? 'var(--color-core-neutral-10)' : 'var(--alert-active)'"
            [name]="validatePasswordLength(password) ? 'check' : 'minus'"
            *ngIf="submitted"
          ></app-ds-icon>
          {{ 'personal.newPassword.tips.li1' | translate }}
        </li>
        <li class="ds-ui-3" [ngClass]="{ check: passNum, error: submitted && hasError && !passNum }">
          <app-ds-icon
            size="icon-size-0"
            [color]="passNum ? 'var(--color-core-neutral-10)' : 'var(--color-core-neutral-6)'"
            [name]="passNum ? 'check' : 'minus'"
            *ngIf="!submitted"
          ></app-ds-icon>
          <app-ds-icon
            size="icon-size-0"
            [color]="passNum ? 'var(--color-core-neutral-10)' : 'var(--alert-active)'"
            [name]="passNum ? 'check' : 'minus'"
            *ngIf="submitted"
          ></app-ds-icon>
          {{ 'personal.newPassword.tips.li2' | translate }}
        </li>
        <li class="ds-ui-3" [ngClass]="{ check: passUpperCase, error: submitted && hasError && !passUpperCase }">
          <app-ds-icon
            size="icon-size-0"
            [color]="passUpperCase ? 'var(--color-core-neutral-10)' : 'var(--color-core-neutral-6)'"
            [name]="passUpperCase ? 'check' : 'minus'"
            *ngIf="!submitted"
          ></app-ds-icon>
          <app-ds-icon
            size="icon-size-0"
            [color]="passUpperCase ? 'var(--color-core-neutral-10)' : 'var(--alert-active)'"
            [name]="passUpperCase ? 'check' : 'minus'"
            *ngIf="submitted"
          ></app-ds-icon>
          {{ 'personal.newPassword.tips.li3' | translate }}
        </li>
        <li class="ds-ui-3" [ngClass]="{ check: passLowerCase, error: submitted && hasError && !passLowerCase }">
          <app-ds-icon
            size="icon-size-0"
            [color]="passLowerCase ? 'var(--color-core-neutral-10)' : 'var(--color-core-neutral-6)'"
            [name]="passLowerCase ? 'check' : 'minus'"
            *ngIf="!submitted"
          ></app-ds-icon>
          <app-ds-icon
            size="icon-size-0"
            [color]="passLowerCase ? 'var(--color-core-neutral-10)' : 'var(--alert-active)'"
            [name]="passLowerCase ? 'check' : 'minus'"
            *ngIf="submitted"
          ></app-ds-icon>
          {{ 'personal.newPassword.tips.li4' | translate }}
        </li>
      </ul>
    </div>
  </div>
}
